import axios from 'axios';

const TOKEN_KEY = 'natur_admin_token';

export const getToken = () => sessionStorage.getItem(TOKEN_KEY);
export const setToken = (t) => sessionStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => sessionStorage.removeItem(TOKEN_KEY);

// Sesión segura elevada (PIN maestro): 10 min o hasta cambio de ventana
let elevated = null;
export const getElevated = () => (elevated && Date.now() < elevated.exp ? elevated.token : null);
export const setElevated = (token) => { elevated = { token, exp: Date.now() + 9.5 * 60 * 1000 }; };
export const clearElevated = () => { elevated = null; };

window.addEventListener('blur', () => { elevated = null; });

axios.interceptors.request.use((cfg) => {
  const t = getToken();
  if (t && !cfg.headers.Authorization) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

axios.interceptors.response.use((r) => r, (err) => {
  const url = err.config?.url || '';
  if (err.response?.status === 401 && getToken() && !url.includes('/portal/')) {
    clearToken();
    elevated = null;
    window.dispatchEvent(new Event('natur-logout'));
  }
  return Promise.reject(err);
});

export function formatApiError(detail, fallback = 'Ha ocurrido un error') {
  if (!detail) return fallback;
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || '').filter(Boolean).join(' ') || fallback;
  return detail.msg || fallback;
}
